import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

import {
  Bar,
  Line,
  Pie
} from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend
);

const API = "/api";

const EstadisticasDominical = () => {

  const [servicios, setServicios] = useState([]);
  const [clases, setClases] = useState([]);
  const [visitantes, setVisitantes] = useState([]);
  const [faltas, setFaltas] = useState([]);

  useEffect(() => {
    cargar();
  }, []);

  const cargar = async () => {
    const r1 = await fetch(`${API}/asistencia/estadisticas/servicios`, { credentials: "include" });
    const r2 = await fetch(`${API}/asistencia/estadisticas/clases`, { credentials: "include" });
    const r3 = await fetch(`${API}/asistencia/estadisticas/visitantes`, { credentials: "include" });
    const r4 = await fetch(`${API}/asistencia/estadisticas/faltas`, { credentials: "include" });

    setServicios(await r1.json());
    setClases(await r2.json());
    setVisitantes(await r3.json());
    setFaltas(await r4.json());
  };

  /* GRAFICA ASISTENCIA */
  const serviciosData = {
    labels: servicios.map((s) => new Date(s.fecha).toLocaleDateString("es-MX", { timeZone: "UTC" })),
    datasets: [
      {
        label: "Total asistencia",
        data: servicios.map((s) => s.total),
        backgroundColor: "#4f46e5",
      },
    ],
  };

  /* CRECIMIENTO CLASES */
  const clasesData = {
    labels: clases.map((c) => c.clase),
    datasets: [
      {
        label: "Asistencia",
        data: clases.map((c) => c.asistencia),
        backgroundColor: "#16a34a",
      },
    ],
  };

  /* VISITANTES */
  const visitantesData = {
    labels: visitantes.map((v) => new Date(v.fecha).toLocaleDateString("es-MX", { timeZone: "UTC" })),
    datasets: [
      {
        label: "Visitantes",
        data: visitantes.map((v) => v.visitantes),
        borderColor: "#f59e0b",
        backgroundColor: "#fbbf24",
      },
    ],
  };

  /* FALTAS */
  const faltasData = {
    labels: faltas.map((f) => f.nombre),
    datasets: [
      {
        label: "Faltas",
        data: faltas.map((f) => f.faltas),
        backgroundColor: "#ef4444",
      },
    ],
  };

  return (
    <div className="p-6 bg-slate-50">

      {/* BREADCRUMB */}
      <div className="text-sm text-slate-400 mb-3">
        <Link to="/dashboard/asistencia" className="hover:text-indigo-600 flex items-center gap-1 inline-flex">
          <FaArrowLeft className="text-xs" /> Asistencia
        </Link>
      </div>

      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Estadísticas Escuela Dominical</h1>
        <p className="text-sm text-slate-500 mt-0.5">Resumen y tendencias de asistencia.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <h2 className="text-base font-semibold text-slate-800 mb-4">Asistencia por servicio</h2>
          <Bar data={serviciosData} />
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <h2 className="text-base font-semibold text-slate-800 mb-4">Crecimiento por clase</h2>
          <Bar data={clasesData} />
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <h2 className="text-base font-semibold text-slate-800 mb-4">Visitantes por servicio</h2>
          <Line data={visitantesData} />
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <h2 className="text-base font-semibold text-slate-800 mb-4">Alumnos con faltas consecutivas</h2>
          <Pie data={faltasData} />
        </div>

      </div>
    </div>
  );
};

export default EstadisticasDominical;
